// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Universal box-sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n", "",{"version":3,"sources":["webpack://./src/taskpane/ui/styles/global.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;;;EAGE,sBAAsB;AACxB","sourcesContent":["/* Universal box-sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
